<template>
  <div class="userInfo-wrapper">
    <div class="avater-wrapper">
      <img :src="avatar" alt="头像" />
      <div class="user-name-box">{{ userInfo.name }}</div>
    </div>
    <div class="detail-wrapper">
      <div class="detail-item-wrapper">
        <span class="label word2">性别</span>:
        <span class="value">{{ gender(userInfo.gender) }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word4">开通时间</span>:
        <span class="value">{{
          parseTime(userInfo.created, '{y}-{m}-{d}')
        }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word2">年龄</span>:
        <span class="value">{{ userInfo.age }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word4">到期时间</span>:
        <span class="value">{{ expireDate }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word2">手机号</span>:
        <span class="value">{{ userInfo.mobile }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word4">剩余天数</span>:
        <span class="value">{{ userInfo.openDay - userInfo.usedDay }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word2">账户</span>:
        <span class="value">{{ account }}</span>
      </div>
      <div class="detail-item-wrapper">
        <span class="label word4">已训练天数</span>:
        <span class="value">{{ usedDay }}</span>
      </div>
    </div>
    <div class="button">
      <el-button round type="primary" @click="handleCharge">立即续费</el-button>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { parseTime, minAndSecond, gender } from '@utils'
import boy from '@/assets/images/boy.png'
import girl from '@/assets/images/girl.png'

const moduleUser = namespace('user')

@Component({
  components: {},
})
// 注意修改class名
export default class UserInfo extends Vue {
  @Prop(Object)
  data

  @Emit('charge')
  postCharge() {}

  @moduleUser.State userInfo
  @moduleUser.Getter expireDate
  @moduleUser.Getter usedDay
  @moduleUser.Getter account

  parseTime = parseTime
  minAndSecond = minAndSecond
  gender = gender

  get avatar() {
    return Number(this.userInfo.gender) === 0 ? boy : girl
  }
  handleCharge() {
    this.postCharge()
  }
}
</script>

<style lang="scss" scoped>
.userInfo-wrapper {
  position: relative;
  width: 100%;

  height: 257px;
  background: #fffbd5;
  border-radius: 40px;
  display: flex;
  align-items: center;
  .avater-wrapper {
    display: flex;
    height: 100%;
    padding: 30px 140px 0;
    position: relative;
    text-align: center;
    img {
      width: 177px;
      height: 177px;
    }
    .user-name-box {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translate(-50%, 0%);
      z-index: 100;
      width: auto;
      height: 40px;
      background: #e78644;
      border-radius: 20px;
      font-size: 24px;
      font-family: Yuanti SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 40px;
      // todo 注意lineheight 和这个的影响
      padding: 0px 41px;
      // todo 禁止文本换行
      white-space: nowrap;
      // 文本换行
    }
    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 117px;
      background: #ffc550;
      opacity: 0.3;
      transform: translateY(50%);
    }
  }
  .detail-wrapper {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    font-size: 20px;
    font-family: FZZhunYuan-M02S;
    font-weight: 400;
    color: #666666;
    padding: 60px 90px 60px 100px;
    align-items: center;
    .detail-item-wrapper {
      display: flex;
      width: 50%;
      padding-bottom: 20px;
      .label {
        display: block;
        min-width: 60px;
        text-align: justify;
        text-align-last: justify;
        padding-right: 5px;
      }
      .value {
        padding-left: 15px;
      }
    }
  }
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 160px 0 120px;
    height: 100%;
    position: relative;
    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 117px;
      background: #ffc550;
      opacity: 0.3;
      transform: translateY(50%);
    }
  }
}
.word2 {
  width: 70px;
}
.word4 {
  width: 120px;
}
.el-button {
  width: 180px;
  height: 50px;
  background: #f8ac34;
  border-radius: 25px;
  border: none;
  font-size: 20px;
  font-family: FZZhunYuan-M02S;
  font-weight: 500;
  // todo 子的间距怎么写
}
</style>
